import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from '../common.service';

@Component({
  selector: 'app-confirm-email',
  templateUrl: './confirm-email.component.html',
  styleUrls: ['./confirm-email.component.css']
})
export class ConfirmEmailComponent implements OnInit {

  emailConfirmOk: boolean = true;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private commonService: CommonService,
  ) { }

  error: string = null;

  ngOnInit() {
    console.log("Confirm email ngOnInit.");
    let confirmEmailTicket = localStorage.getItem('CONFIRM_EMAIL_TICKET');

    if (!confirmEmailTicket) {
        console.log("confirmEmailTicket not in local storage");
        let ticket = null;

        this.route.queryParams.subscribe(params => {
            ticket = params['ticket'];
          });

        localStorage.setItem('CONFIRM_EMAIL_TICKET', ticket);
        console.log("Ticket : " + ticket);
        if (ticket==null) {
          this.emailConfirmOk = false;
          document.getElementById('windowMsg').innerHTML = "Token di conferma email non valido.";
          return;
        }
    
        this.commonService.getRegistrationService().authEmailConfirmationGet(ticket).subscribe(
          () => {
            this.emailConfirmOk = true;     
            console.log("Email Confirmed");   
          },
          (error) => {        
            this.emailConfirmOk = false;
            document.getElementById('windowMsg').innerHTML = "Token di conferma email non valido.";
            console.log("Error = " + error);
          }
        );
    } else {
        console.log("confirmEmailTicket in local storage");
        localStorage.removeItem('CONFIRM_EMAIL_TICKET');
        console.log("confirmEmailTicket removed from local storage")
    }

  }

}
